orders-planner-schedules-cell(class="{over: opts.onOver}")
  .memos
    orders-planner-schedules-memo(each="{empty, index in this.number}" if="{!empty}" tag-scope="{this.genTagScopeForMemo(index)}" data-index="{index}")
  script(type="typescript").
    this.mixin('orders.planner.schedules.cell');
